import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Root } from 'data/result/result.model';

type SliceState = {
  status: 'idle' | 'loading' | 'data' | 'error';
  data: Root;
  error: any;
};

const initState: SliceState = {
  status: 'idle',
  data: {
    testTypeAndContributionPair: [],
    subjects: [],
    class: '',
    sections: [],
  },
  error: false,
};

const setLoading = (): SliceState => ({ ...initState, status: 'loading' });

const setData: CaseReducer<SliceState, PayloadAction<Root>> = (_, action) => ({
  error: false,
  data: action.payload,
  status: 'data',
});

const setError: CaseReducer<SliceState, PayloadAction<any>> = (state, action) => ({
  error: action.payload,
  data: {
    testTypeAndContributionPair: [],
    subjects: [],
    class: '',
    sections: [],
  },
  status: 'error',
});

const termAggregatedResultsSlice = createSlice({
  name: 'termAggregatedResults',
  initialState: initState,
  reducers: {
    setLoading,
    setData,
    setError,
  },
});

export default termAggregatedResultsSlice;
